import { render, staticRenderFns } from "./SucceedPage.vue?vue&type=template&id=5a2ad5c1&scoped=true"
import script from "./SucceedPage.vue?vue&type=script&lang=js"
export * from "./SucceedPage.vue?vue&type=script&lang=js"
import style0 from "./SucceedPage.vue?vue&type=style&index=0&id=5a2ad5c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ad5c1",
  null
  
)

export default component.exports